import type { CountryLanguages } from '~/types/countryLanguages';
import type { CountryEntryStoryblok } from '~storyblok-types/CountryEntryStoryblok';

export type CountryListItem = {
    key: string;
    name: string;
    flagUrl?: string;
    flagAlt?: string;
    languages: string[];
    defaultLanguage?: string;
};

export const normalizeCountryEntries = (entries: CountryEntryStoryblok[]): CountryListItem[] => {
    return (entries || [])
        .filter(
            (entry) =>
                Boolean(entry.countryId) &&
                Array.isArray(entry.availableLanguages) &&
                entry.availableLanguages.length > 0
        )
        .map((entry) => ({
            key: entry.countryId!,
            name: entry.displayName || entry.countryId!,
            flagUrl: entry.flagIcon?.filename || undefined,
            flagAlt: entry.flagIcon?.alt || entry.displayName || entry.countryId,
            languages: (entry.availableLanguages || []).map(String).filter(Boolean)
        }))
        .filter((item) => item.languages.length > 0);
};

export const buildCountryLanguagesMap = (normalizedCountries: CountryListItem[]): CountryLanguages => {
    const countryLanguages: CountryLanguages = {};

    for (const normalizedCountry of normalizedCountries) {
        countryLanguages[normalizedCountry.key] = {
            availableLanguages: normalizedCountry.languages,
            defaultLanguage: normalizedCountry.languages[0]
        };
    }

    return countryLanguages;
};
